<div class="day-time-selector">
    <div class="badges-container">
        <div class="badges">
            <span *ngFor="let badge of badges; let i = index" class="badge-item">
                {{ badge.day }}, {{ formatTime(badge.start) }} - {{ formatTime(badge.end) }}
                <button type="button" class="badge-close" aria-label="Close" (click)="remove(i)">
                    <mat-icon>close</mat-icon>
                </button>
            </span>
        </div>
        <button type="button" class="add-btn" (click)="toggleForm()">
            <mat-icon *ngIf="!showForm">add</mat-icon>
            <mat-icon *ngIf="showForm">close</mat-icon>
        </button>
    </div>
    <div *ngIf="showForm" class="form-container">
        <form [formGroup]="dayTimeForm" class="schedule-form">
            <div class="form-row">
                <div class="form-field">
                    <select formControlName="day" class="form-control">
                        <option value="null" disabled>Select Day</option>
                        <option *ngFor="let day of days" [value]="day">{{ day }}</option>
                    </select>
                </div>
                <div class="form-field">
                    <input type="time" formControlName="start" class="form-control">
                </div>
                <div class="form-field">
                    <input type="time" formControlName="end" class="form-control">
                </div>
                <div class="form-field-btn">
                    <button type="button" class="submit-btn" (click)="add()">Add</button>
                </div>
            </div>
        </form>
    </div>
</div>